module.exports = __webpack_public_path__ + "static/media/christian-dior-jadore-big.49cefaef.png";